import $ from "jquery";
import { EldmlTransform } from "./EldmlTransform";

export class ImagesTransform extends EldmlTransform {
  apply() {
    this.selector
      .find("img:not(.fancy-image):not(.dataitem-avatar)")
      .each((_, img) => {
        if (
          $(img).parentsUntil(this.selector, "a").length === 0 &&
          $(img).parentsUntil(this.selector, ".action-button").length === 0
        ) {
          $(img).addClass("fancy-image");
        }
        const fileKey = $(img).attr("filekey");
        const src = $(img).attr("src");
        if (fileKey && !src) {
          this.transformer
            .getImageSrc(fileKey, $(img).attr("source"))
            .then((src) => $(img).attr("src", src));
        } else if (this.transformer.mobile && src) {
            const fileKeyRegex = /k=([0-9a-fA-F-]+)(?:&s=([fbm]))?/;
            const match = src.match(fileKeyRegex);
            if(match) {
                const fileKey = match[1];
                const source = match.length > 1 ? match[2] : undefined;
                this.transformer
                    .getImageSrc(fileKey, source)
                    .then((src) => $(img).attr("src", src));
            }
        }
      });

    this.selector
      .off("click.image")
      .on("click.image", "img.fancy-image", (e) => {
        e.stopPropagation();
        e.preventDefault();
        const src = $(e.currentTarget).attr("src");
        if (src) {
          this.transformer.onImageClick(e.currentTarget, src);
        }
      });
  }
}
